export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["从"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["至"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["字符"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["无效值"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["必填字段"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["检查字段"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["最大"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SVG、PNG 或 JPG"])}
}